import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
const ChevronLarge = ({ className }) => {
    return (_jsxs("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: cn(className), children: [_jsx("rect", { x: "1", y: "1", width: "38", height: "38", rx: "19", stroke: "#5B6E7F", strokeWidth: "2" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 22.7092L26.532 16.5L28 17.8954L20 25.5L12 17.8954L13.468 16.5L20 22.7092Z", fill: "#5B6E7F" })] }));
};
export default ChevronLarge;
